// Site Components
import SmoothScroll from "./SmoothScroll";
import Header from "./Header";
import Navigation from "./Navigation";
import Cursor from "./Cursor";
import ScrollBar from "./ScrollBar";

// Page Components
import Animations from "./Animations";
import ImageReveal from "./ImageReveal";
import MarqueeText from "./MarqueeText";
import MagneticButton from "./MagneticButton";
import ScrollUpDown from "./ScrollUpDown";
import TeamCarousel from "./TeamCarousel";
import PortfolioList from "./PortfolioList";
import PortfolioSlider from "./PortfolioSlider";
import FullScreenTabs from "./FullScreenTabs";
import Accordions from "./Accordions";

export const siteComponents = {
	SmoothScroll,
	Navigation,
	Header,
	Cursor
};

export const pageComponents = {
	ScrollBar,
	MarqueeText,
	Animations,
	ImageReveal,
	MagneticButton,
	ScrollUpDown,
	TeamCarousel,
	PortfolioList,
	PortfolioSlider,
	FullScreenTabs,
	Accordions
};
